import { DispositionStatusResponse } from '@/types/service-response'

export class DispositionJobStatus {
  public constructor (
    readonly id: number,
    readonly label: string
  ) {}

  static createFromResponse (responseData: DispositionStatusResponse[]): Array<DispositionJobStatus> {
    let result: Array<DispositionJobStatus> = []
    if (responseData) {
      result = responseData.map((item: DispositionStatusResponse ) => {
        return new DispositionJobStatus(
          item.ID,
          item.Value
        )
      })
    }
    return result
  }
}
